<template>
	<el-card>
        <div slot="header">
            <span class="top_title">新增产品发货</span>
        </div>
        <div class="searchItem">
            <div class="search" style="display:flex">
                <span class="searchtips">产品:</span>
                <SearchBox @changeSelect="changeSelect($event)" ref="sb1"></SearchBox>
            </div>
            <div class="search">
                <span class="searchtips">发货日期:</span>
                <el-date-picker
                    v-model="date"
                    type="datetime"
                    placeholder="发货日期"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    style="width: 180px"
                    :editable="false"
                />
            </div>
            <div class="search" v-if="$common.hasLimits('stockInfo')">
                <span class="searchtips">生成出库记录:</span>
                <el-switch
                    @change="changeSwitch"
                    v-model="out"
                    :active-value="1"
                    :inactive-value="0"
                />
            </div>
            <div class="search">
                <el-button type='primary' @click="selectProduct()">搜索</el-button>
            </div>
        </div>
        <el-button @click="colsDialog = !colsDialog" style="height:40px;margin-bottom:22px">
            列设置
        </el-button>
		<SPTable v-loading="loading" :productModel="false" ref="spt" :cols='cols' :autoAdd='true' @returnData="saveSend"></SPTable>
        <div style="margin-top:20px">
            <span style="padding-right:10px;line-height:60px">备注:</span>
            <el-input
                v-model="remark"
                type="textarea"
                maxlength="150"
                style="width: 480px"
            />
        </div>
		<div class="rootbtn">
            <el-button type="primary" @click="getData">确认</el-button>
		</div>
        <el-dialog :visible.sync="colsDialog" title="列设置" width="60%">
			<column-edit :cols="editCols" :setColumn="false" :hideMode="true" />
			<div slot="footer" class="dialog-footer" v-if="$global.userType==0">
                <el-button type="text" @click="resetCols()" style="float:left">恢复默认设置</el-button>
				<el-button type="primary" @click="saveCols">保存</el-button>
			</div>
		</el-dialog>
        <ReportOrder ref="roder"></ReportOrder>
	</el-card>
</template>

<script>
import ColumnEdit from '@/components/table-column/Column.vue';
import Customer from "../../components/customer.vue";
import SPTable from  "../../components/table-column/supertable.vue";
import ReportOrder from '../../components/printshare/reportorder'
export default {
    components: {Customer,SPTable,ReportOrder,ColumnEdit},
    data() {
        return {
            editCols:[],
            cols: [],
            pids:"",
            productList:[],
            loading:false,
            out:this.$common.hasLimits('stockInfo')?1:0,
            remark:'',
            date: this.$common.format(new Date()),
            colsDialog:false,
        }
    },
    mounted(){
        if(this.$global.userType==0){
            this.$api.getTableCols({tableName: 'ipad_AddProSendList'}).then(res=>{
                if(res.data.code==1){
                    this.resetCols(res.data.data.cols);
                }else{
                    this.resetCols();
                }
                if(this.$common.hasLimits('stockInfo')){
                    this.changeSwitch(1);
                }else{
                    this.changeSwitch(0);
                }
            })
        }else if(this.$global.userType==1){
            this.resetCols();
        }
    },
    methods: {
        changeSelect(e){
            this.pids = e;
        },
        resetCols(val){
            this.editCols = [];
            this.cols = [];
            let noStore = true;
            if(this.$common.hasLimits('stockInfo')){
                noStore = false;
            }
            if(!val){
                val = [false,false,false,false,false,false,false,false,false];
            }
            var obj = {
                prop: "odate",
                label: "订货日期",
                edit:'',
                type: "",
                width: 120,
                hide:val[0], 
            }
            this.cols.push(obj);
            this.editCols.push(obj);
            var obj0 = {
                prop: "pname",
                label: "产品",
                edit:'',
                type: "sproductEdit",
                width: 240,
                hide:val[1],
            }
            this.cols.push(obj0);
            this.editCols.push(obj0);
            var obj1 = {
                prop: "cname",
                label: "客户",
                edit:'',
                type: "",
                width: 160,
                hide:val[1],
            }
            this.cols.push(obj1);
            this.editCols.push(obj1);
            var obj2 = {
                prop: "img",
                label: "图片",
                edit:'',
                type: "imgEdit",
                width: 56,
                hide:val[2],
            }
            this.cols.push(obj2);
            this.editCols.push(obj2);
            var obj3 = {
                prop: "unit",
                label: "包装单位",
                edit:'',
                type: "unitEdit",
                width: 130,
                hide:val[3],
            }
            this.cols.push(obj3);
            this.editCols.push(obj3);
            var obj4 = {
                prop: "count",
                label: "发货("+this.$global.pack+")",
                edit:'countEdit',
                type: "countLimitEdit",
                width: 130,
                unit:this.$global.pack,
                hide:this.$global.buyType==2?true:false,
            }
            this.cols.push(obj4);
            var obj5 = {
                prop: "num",
                label: "发货("+this.$global.unit+")",
                edit:'numEdit',
                type: "countLimitEdit",
                width: 130,
                unit:this.$global.unit,
                hide:this.$global.buyType==1?true:false,
            }
            this.cols.push(obj5);
            var obj6 = {
                prop: "orderunit",
                label: "订货总数",
                edit:'',
                type: "",
                width: 130,
                hide:val[4],
            }
            this.cols.push(obj6);
            this.editCols.push(obj6);
            var obj7 = {
                prop: "sendDesc",
                label: "已发数量",
                edit:'',
                type: "",
                width: 130,
                hide:val[5],
            }
            this.cols.push(obj7);
            this.editCols.push(obj7);
            var obj8 = {
                prop: "notSendDesc",
                label: "未发数量",
                edit:'',
                type: "notSendEdit",
                width: 130,
                hide:val[6],
            }
            this.cols.push(obj8);
            this.editCols.push(obj8);
            var obj9 = {
                prop: "store",
                label: "仓库",
                edit:'whEdit',
                type: "whEdit",
                width: 130,
                showName:'storename',
                main:1,
                hide:noStore,
            }
            this.cols.push(obj9);
            var obj10 = {
                prop: "stock",
                label: "库存",
                edit:'',
                type: "stockEdit",
                width: 130,
                hide:noStore,
            }
            this.cols.push(obj10);
            var obj11 = {
                prop: "price",
                label: "单价(元)",
                edit:'',
                type: "",
                width: 130,
                hide:val[7],
            }
            this.cols.push(obj11);
            this.editCols.push(obj11);
            var obj12 = {
                prop: "remark",
                label: "备注",
                edit:'',
                type: "",
                width: 130,
                hide:val[8],
            }
            this.cols.push(obj12);
            this.editCols.push(obj12);
        },
        saveCols(){
            let arr = [];
            this.editCols.forEach(e=>{
                arr.push(e.hide);
            })
            let obj = {
                tableName:'ipad_AddProSendList',
                data:JSON.stringify(arr),
            }
            this.$api.setTableCols(obj).then(res=>{
                if(res.data.code==1){
                    this.$notify({
                        title: "列设置",
                        message: "修改成功",
                        type: "success",
                        duration: 2000,
                    });
                }
            })
            this.colsDialog = false;
        },
        changeSwitch(e){
            if(e==1){
                this.cols[10].hide = false;
                this.cols[11].hide = false;
            }else{
                this.cols[10].hide = true;
                this.cols[11].hide = true;
            }
        },
        selectProduct(){
            if(!this.pids){
                return;
            }
            this.loading = true;
            let v = this.pids.split(',');
            let arr = [];
            v.forEach(e=>{
                let obj = {
                    pid:e,
                }
                arr.push(obj);
            })
            this.$api.getProductNotSendOrderDetail({prods:JSON.stringify(arr)}).then(res=>{
                if(res.data.code==1){
                    this.$refs.spt.setData(res.data.data,(o,e)=>{
                        o.id = e.odid;
                        o.cid = e.cid;
                        o.cname = e.cnumber+' '+e.cname;
                        o.odate = e.odate;
                        o.spec = e.color?e.color+"/"+e.size:"默认";
                        o.pname = e.pnumber+' '+e.pname+"_"+o.spec;
                        o.unit = e.punit;
                        o.orderunit = this.$common.changeNumDesc(e);
                        o.sendDesc = this.$common.changeNumDesc(e,'sendedAmount','sendedParts','sendedUnit');
                        o.notSendDesc = this.$common.changeNumDesc(e,'notSendAmount','notSendParts','notSendUnit');
                        o.img = '';
                        if(e.img.length>0&&e.img[0]){
                            o.img = this.$api.baseURL+e.img[0];
                        }
                        o.price = e.price?e.price:0;
                        o.count = 0;
                        o.num = 0;
                        o.maxnum = e.notSendUnit;
                        o.countEdit = false;
                        o.numEdit = false;
                        o.whEdit = false;
                        o.stockList = {};
                        o.remark = e.remark;
                        if(e.stockW.length>0){
                            let index = -1;
                            var slid = 0;
                            e.stockW.forEach(ss=>{
                                index++;
                                ss.stDesc = this.$common.changeNumDesc(ss,'stockAmount','stockParts','stock');
                                if(ss.id==e.wid){
                                    slid = index;
                                }
                                let obj = {
                                    negative:ss.negative,
                                    stock:ss.stock,
                                    name:ss.name,
                                    id:ss.id,
                                    stDesc:ss.stDesc,
                                }
                                o.stockList[ss.id] = obj;
                            })
                            o.store = e.stockW[slid].id;
                            o.stock = e.stockW[slid].stock;
                            o.stDesc = e.stockW[slid].stDesc;
                            o.negative = e.stockW[slid].negative;
                            o.storename = e.stockW[slid].name;
                        }
                    });
                }
                this.loading = false;
            })
        },
        getData(){
            this.$refs.spt.getData();
        },
        saveSend(formData) {
            if(!this.$common.hasLimits('stockInfo')){
                this.out = 0;
            }
            let obj = {
                contact:this.contact,
                date:this.date,
                remark:this.remark,
                stock:this.out,
            }
            let detail = [];
            formData.forEach(e=>{
                if(e.num>0||e.count>0){
                    let obj1 = {
                        odid:e.id,
                        sendParts:e.num,
                        sendAmount:e.count,
                        sendUnit:e.num+e.count*e.unit,
                        cid:e.cid,
                    }
                    if(this.out==1){
                        obj1.wid = e.store?e.store:'';
                    }
                    detail.push(obj1);
                }
            })
            if(detail.length>0){
                obj.detail = JSON.stringify(detail);
                this.$api.addProductSend(obj).then(res=>{
                    if(res.data.code==1){
                        let id = res.data.data;
                        let arr = [];
                        arr.push(id);
                        this.$nextTick(()=>{
                             this.$refs.roder.extraCheckOpen(1,arr,()=>{
                                this.$router.push("/send");
                                this.$notify({
                                    title: "产品发货",
                                    message: "产品发货成功",
                                    type: "success",
                                    duration: 1500,
                                });
                             });
                        })
                    }else{
                        this.$common.error(res.data.msg);
                    }
                })
            }else{
                this.$common.error("没有数据");
            }
        },
    },
}
</script>
